module.exports = require('./Loading.vue');


//////////////////
// WEBPACK FOOTER
// ./~/vue-full-loading/src/index.js
// module id = 6
// module chunks = 0